import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ServicesOneCard from './ServicesOneCard';
import Icon1 from '../../assets/img/icon/s1.png';
import defaultImage from '../../assets/img/gallery/9.jpg';
import { useApi } from '../../middleware/middleware';
import { useLocation } from 'react-router-dom';
import { extractIdFromUrlPath } from '../../helpers/concatUrlPath';
import { Helmet } from 'react-helmet';
import suCrypt from '../../helpers/suCrypt';

function Services6() {
    const location = useLocation();
    const [categoryId,setCategoryId] = useState(
        extractIdFromUrlPath(location.pathname || '')
    );
    useEffect(()=>{
       setCategoryId(
        extractIdFromUrlPath(location.pathname || '')
       ); 
    },[location.pathname]);
    
    
    const { data, error, isLoading } = useApi('products_by_standards_subcategory', { catID: categoryId });
    const {data: title, error: title_error, isLoading: title_loading} = useApi('standard_by_id', { id: categoryId });
    console.log("title: ",title);


    return (
        <>
            <Helmet>
                <title>{`Testfabrics.com: ${title?.[0].name.slice(0,50) || 'PRODUCT BY STANDARDS SUBCATEGORY' }`}</title>
            </Helmet>
            <section className="page-banner-wrap-2 ">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="breadcrumb-wrap">
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to={"/"}>Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <Link to={location.pathname}>{title?.[0].name}</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            {"Sub Categories"}
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            {/* <div className="page-heading">
                                <h2>Sub Categories</h2>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            <section className="services-wrapper services-1 section-bg section-padding">
                <div className="container">
                    <div className="row">
                    </div>
                    <div className="row">
                        {
                            (data && data.length > 0) ? (
                                data.map((item, index) => (
                                    <ServicesOneCard
                                        key={item.methods__ID}
                                        sucategoryId={item.methods__ID}
                                        bgImg={item.img}
                                        defaultImg={defaultImage}
                                        icon={Icon1}
                                        heading={item.methods__Name}
                                        subHeading={item?.methods__Description}
                                        btnText={"See Products"}
                                        index={index}
                                        product_count={item.product_count}
                                    />
                                ))
                            ) : <h3>No result Found</h3>
                        }
                    </div>
                </div>
            </section>
        </>
    );
}

export default Services6;
